import { render } from "./IAView.vue?vue&type=template&id=0ede8620&scoped=true"
import script from "./IAView.vue?vue&type=script&lang=js"
export * from "./IAView.vue?vue&type=script&lang=js"

import "./IAView.vue?vue&type=style&index=0&id=0ede8620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ede8620"]])

export default __exports__